export enum RevrollEvent {
  REVROLL_VIEW_ITEM = 'rr_view_item',
  REVROLL_ADD_TO_CART = 'rr_add_to_cart',
  REVROLL_BEGIN_CHECKOUT = 'rr_begin_checkout',
  REVROLL_PURCHASE = 'rr_purchase',
}
